import axios from "axios";
import { API_URL,SERVER_URL } from '../Constants';

class QualityControlService{
    getAllProjects(accessToken) {
        return axios.get(`${API_URL}getQCCompleteProjects/`,{headers:{'Authorization':accessToken}});
    };

    uploadQCList(accessToken,projectId,qcList,deleteNotFound){
        return axios.post(`${API_URL}addLineItemsToQCListsByProject/`,{projectId,qcList,deleteNotFound},{headers:{'Authorization':accessToken}});
    };

    importQCList(accessToken,importDocument){
        console.log(importDocument)
        const formData = new FormData();
        formData.append('file', importDocument);
        return axios.post(`${API_URL}importQCListByProject/`,formData,{headers:{'Authorization':accessToken}});
    };

    uploadManualEdits(accessToken, activeUser, projectId, updates ) {
        return axios.post(`${API_URL}updateQCListsByProject/`, { projectId: projectId, updateObject: updates, activeUser }, { headers: { 'Authorization': accessToken } });
    };

    getQCTemplate(){
        window.open(`${API_URL}blankQCImportTemplate/`)
    };

    getProjectData(sessionId, projectId) {
        return axios.get(`${API_URL}getQCProjectData/${sessionId}/${projectId}`);
    };

    getQCCategoriesList() {
        return axios.get(`${API_URL}getQCCategoriesList/`);
    };

    updateQCItem(sessionId, projectId, categoryKey, itemId, updates) {
        return axios.post(`${API_URL}updateQCItem/${sessionId}/${projectId}`, {
            categoryKey,
            itemId,
            updates
        });
    };

    batchUpdateQCItems(sessionId, projectId, updateObject, userName) {
        const sendableObject = {
            sessionId,
            projectId,
            updateObject,
            userName
        };
        return axios.post(`${API_URL}updateQCItemsBySession/`, sendableObject);
    };

    getQCDataByProject(apiToken, projectId) {
        return axios.get(`${API_URL}getAllQCProjectData/${projectId}`, { headers: { 'Authorization': apiToken } });
    };

    getCompleteQCReport(apiToken) {
        return axios.get(`${API_URL}getCompleteQCReport/`, { headers: { 'Authorization': apiToken } });
    };

    downloadCompleteQCReport(apiToken, filename) {
        window.open(`${SERVER_URL}${filename}`, {headers:{'Authorization':apiToken}})
    };

    getInitializedTemplate() {
        window.open(`${API_URL}blankQCInitializeTemplate/`)
    };

    submitInitializedFile(apiToken, initializedFile) {
        const formData = new FormData();
        formData.append('file', initializedFile);
        return axios.post(`${API_URL}uploadInitializedFile/`, formData, { headers: { 'Authorization': apiToken } });
    };

    submitInitializedObject(apiToken, projectId, initializedObject) {
        return axios.post(`${API_URL}initializeQCListByProject/`, { projectId, initializedObject }, { headers: { 'Authorization': apiToken } });
    };

    getProjectSpecificReport(apiToken, projectId) {
        return axios.get(`${API_URL}getProjectSpecificQCReport/${projectId}`, { headers: { 'Authorization': apiToken } });
    };

    downloadProjectSpecificReport(apiToken, filename) {
        window.open(`${SERVER_URL}${filename}`, {headers:{'Authorization':apiToken}})
    };

    importQCListUpdate(apiToken, importDocument, projectNumber){
        const formData = new FormData();
        formData.append('file', importDocument);
        formData.append('projectNumber', projectNumber);
        return axios.post(`${API_URL}importQCListUpdate/`,formData,{headers:{'Authorization':apiToken}});
    };

    getAllProjectIssueLogs(apiToken, projectId) {
        return axios.get(`${API_URL}getQCIssueLogs/${projectId}`, { headers: { 'Authorization': apiToken } });
    };
};

QualityControlService = new QualityControlService();
export default QualityControlService;